import React from "react";
const SignUpFinish = () => {
  return (
    <>
      <div className="wrapper">
        <div className="signup-wrapper py-5">
          <div className="container d-flex align-items-center justify-content-center">
            <div className="row signupbox">
              <div
                className="col-md-4 px-5 py-3 d-flex flex-column"
                style={{ minHeight: "100%" }}
              >
                <div className="row ">
                  <div className="col-md-12 mt-4">
                    <img src="images/logo.svg" height="65px" alt="/" />
                  </div>
                  <div className="col-md-12 mt-5">
                    <ol className="steps">
                      <li className="active">
                        <div className="step-item">
                          <div>
                            <h3 className="step-finish-h">
                              Setup completed! Thank you!
                            </h3>
                          </div>
                        </div>
                      </li>
                    </ol>
                  </div>
                </div>

                <div className="mt-auto">
                  <div className="d-flex aic" style={{ marginBottom: "100px" }}>
                    <img
                      className="mr-3"
                      src="/images/setup-loader-img.svg"
                      alt="/"
                    />
                    <p className="info-txt mb-0">
                      Waiting for the verification process to finish.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-8 px-5">
                <div className="row mt-5 px-5">
                  <div className="col-md-12">
                    <div className="about-section">
                      <h4>Finish account setup 2/3)</h4>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="finish-context">
                      <div className="row aic">
                        <div className="col-md-8 col-8">
                          <div className="wrap">
                            <h4>About company</h4>
                            <p>Company details</p>
                          </div>
                        </div>
                        <div className="col-md-4 col-4">
                          <div className="wrap">
                            <div className="progress">
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{ width: "70%", background: "#2C75FF" }}
                                // aria-valuenow="50"
                                // aria-valuemin="0"
                                // aria-valuemax="100"
                              ></div>
                            </div>
                            <p>Verification In-progress</p>
                          </div>
                        </div>
                        <div className="col-md-12 col-4">
                          <div className="border-bottom my-4"></div>
                        </div>
                        <div className="col-md-8 col-8">
                          <div className="wrap">
                            <h4>Who are you?</h4>
                            <p>About you</p>
                          </div>
                        </div>
                        <div className="col-md-4 col-4">
                          <div className="wrap">
                            <div className="complete-img text-right">
                              <img
                                src="/images/setup-complete-check.svg"
                                alt="/"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 col-4">
                          <div className="border-bottom my-4"></div>
                        </div>
                        <div className="col-md-8 col-8">
                          <div className="wrap">
                            <h4>Set a password</h4>
                            <p>Set your password</p>
                          </div>
                        </div>
                        <div className="col-md-4 col-4">
                          <div className="wrap">
                            <div className="complete-img text-right">
                              <img
                                src="/images/setup-complete-check.svg"
                                alt="/"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 col-4">
                          <div className="border-bottom my-4"></div>
                        </div>

                        <div className="col-md-6">
                          <div className="get-started-btn">
                            <button className="btn btn-login btn-block">
                              Verifying
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUpFinish;
